import React, { useState, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import PdfViewer from '../../common/components/modals/pdfViewerModal';
import SetLoadingModal from "../../common/components/modals/setLoadingModal";
import { useAuth } from "../../common/context/clientContext";
import { axiosPost } from "../../common/services/axios/apiCalls"

import ProductButtonContainter from "../container/productButtonContainer"
import ProductListInfoContainter from "../container/productListInfoContainer"
import ProductTableInfoContainer from "../container/productTableInfoContainer"

export default function ProductCard({ productData, properties }) {
    /** CONST */
    const [viewer, setViewer] = useState(false)
    const [fileToView, setFileToView] = useState(null)
    const [pdfModalTitle, setPdfModalTitle] = useState('')
    const { token } = useAuth()

    const navigate = useNavigate();

    const subcategoryCode = productData.group?.subcategory?.code || null;
    const categoryCode = productData.group?.subcategory?.category?.code || null;

    /** FUNCTIONS */
    const navigateToCatalog = () => {
        navigate(`/catalog/${categoryCode}/${subcategoryCode}`);
    }

    const currentDirectory = () => {
        if (!productData.group)
            return <span>'...'</span>;

        return (
            <span className='justify-content-center align-items-center d-flex'>
                {productData.group.subcategory?.category?.name || ''}
                {" / "}
                {productData.group.subcategory?.name || ''}
                {" / "}
                {productData.group.name || ''}
            </span>)
    }

    const downloadFile = async (fileCode, certCode) => {
        const axiosData = {
            productId: productData.uid,
            code: fileCode,
            reference: certCode
        }

        try {
            const response = await axiosPost("/public/file/product/read/details", token, axiosData, { responseType: 'blob' })
            if (!response) {
                throw new Error('Error al descargar el archivo');
            }
            else {
                return response
            }
        } catch (error) {
            return null;
        }
    }

    return (
        <Grid>
            <Grid className="info-panel">
                <div className="w-100 d-flex justify-content-between align-items-center mb-4 px-3">
                    <Grid>
                        <Tooltip title="Volver al catálogo">
                            <IconButton onClick={navigateToCatalog}>
                                <ArrowBackIcon fontSize="large" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    {currentDirectory()}
                </div>
                <Grid id={"product-head"}>
                    <Grid container className="justify-content-center pt-3">
                        <h1 className="catalog-title">{productData.name}</h1>
                    </Grid>
                </Grid>
                {properties.cert &&
                <ProductButtonContainter
                    files={productData.devicefiles}
                    filesProp={properties.cert}
                    downloadFile={downloadFile}
                    setViewer={setViewer}
                    setFileToView={setFileToView}
                    setPdfModalTitle={setPdfModalTitle}
                />
                }
                <Grid container className='justify-content-center' id={"product-legal-info"}>
                    <Grid item className='product-info-legal col-sm-12 col-md-10 col-lg-8'>
                        <p>{productData.legalText}</p>
                    </Grid>
                </Grid>
                <ProductListInfoContainter productData={productData} detailsProp={properties.detail} />
                {properties.table &&
                    <ProductTableInfoContainer productData={productData} detailsProp={properties.table} />
                }

                <Suspense fallback={<SetLoadingModal />}>
                    {viewer &&
                        <PdfViewer
                            setViewer={setViewer}
                            title={pdfModalTitle}
                            blob={fileToView}
                        />}
                </Suspense>
            </Grid>
        </Grid>
    );
}